// Client-side backstop for connections that point at nobody.
//
// Account deletion rewrites a surviving capsule's senderId to this sentinel, so
// it is a uid-shaped string no account will ever own. Any path that bonds a user
// to it (or to a profile with nothing displayable) produces a row that renders
// as "Connection / Inssa connection" in the recipient pickers — selectable, and
// addressed to an account that cannot receive anything.
export const DELETED_USER_ID = "deleted-user";

const IDENTITY_FIELDS = ["displayName", "email", "phoneNumber", "userName", "publicHandle"];

export function isDeletedUserId(uid) {
  return String(uid || "").trim() === DELETED_USER_ID;
}

// Deliberately generous: one usable handle of any kind is enough to keep a real
// person in the list. Only records with nothing at all to show are dropped.
export function hasDisplayableIdentity(record) {
  if (!record || typeof record !== "object") return false;
  return IDENTITY_FIELDS.some((field) => String(record[field] || "").trim());
}

export function filterResolvableConnections(list) {
  if (!Array.isArray(list)) return [];
  return list.filter((record) => {
    const uid = String(record?.uid || "").trim();
    if (!uid || isDeletedUserId(uid)) return false;
    return hasDisplayableIdentity(record);
  });
}
